import React from 'react';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      console.log('❌ Google Map Error >>> ', this.state.error)
      return (
        <div className="map-error">
          <div>Something went wrong while loading map!</div>
          <div className="error-details">{this.state.error?.toString()}</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default MapErrorBoundary;